// Locale-aware formatting. The active locale is set by the I18nProvider.
let _locale = "pl-PL";

export function setLocale(lang) {
  _locale = lang === "en" ? "en-US" : "pl-PL";
}

export function formatMoney(amount, currency = "PLN") {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(_locale, {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    const formatted = n.toLocaleString(_locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currency === "PLN" ? `${formatted} z\u0142` : `${formatted} ${currency}`;
  }
}

export function formatDate(d) {
  if (!d) return "\u2014";
  try {
    const dt = new Date(d + (d.length === 10 ? "T00:00:00" : ""));
    if (isNaN(dt)) return d;
    return dt.toLocaleDateString(_locale, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return d;
  }
}

export function monthLabel(ym) {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  const dt = new Date(Number(y), Number(m) - 1, 1);
  return dt.toLocaleDateString(_locale, { month: "short", year: "2-digit" });
}
